module.exports = __webpack_public_path__ + "assets/images/alimentacao_saude.736d9c78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alimentacao_saude.png
// module id = 385
// module chunks = 1